module.exports = __webpack_public_path__ + "1512a3be08050d310db29ad2f7e2f19a.MP3";